import store from '@/store';
// import defaultSettings from 'settings';
// const { loginInterceptionType } = defaultSettings;
// import { getAccessInstance } from '@/utils/access_token';
import Vue from 'vue';

function dealsrc(urlVal,noDate) {
    let url = '',
        imageUrl = '',
        w = 186,
        h = 'af',
        _v = urlVal;
    if (!_v || (_v && typeof _v === 'string')) {
        imageUrl = _v;
    } else {
        imageUrl = _v.url;
        w = _v.w ? _v.w : w;
        h = _v.h ? _v.h : w;
    }
    if (imageUrl && (imageUrl.includes('images/') || imageUrl.includes('image/') || imageUrl.includes('vedio/'))) {
        let imgA = imageUrl.split('?');
        let nImgUrl = imgA[0];

        const suffix = nImgUrl.substring(nImgUrl.lastIndexOf('.') + 1, nImgUrl.length);
        const sizeSymbol = `_${w}x${h}.${suffix}`;
        let reg = /^http/;
        let ishttp = reg.test(nImgUrl);
        if (nImgUrl.substring(0, 1) !== '/' && !ishttp) {
            nImgUrl = '/' + nImgUrl;
        }
        //如果链接带有_122x150.jpg这种格式，则替换成新的
        if (/_\d+\x\d+\.\w+$/gi.test(nImgUrl)) {
            ///\_\d+\x\d+\.\w+$/gi.test(nImgUrl)
            const targetSymbol = nImgUrl.match(/_(\d+)\x(\d+)\.(\w+)$/i); //(/\_(\d+)\x(\d+)\.(\w+)$/i)
            nImgUrl = nImgUrl.replace(targetSymbol[0], sizeSymbol);
        } else {
            nImgUrl += sizeSymbol;
        }
        url = nImgUrl;
    } else if (imageUrl && (imageUrl.includes('http://') || imageUrl.includes('https://'))) {
        url = imageUrl;
    }

    let k = url.indexOf('?') > -1 ? '&' : '?';
    if (!noDate){
        url = url + k + 't=' + +new Date();
    }    
    return url;
}

export default {
    // 上传前缀
    upLoadUrl() {
        // const isPre = loginInterceptionType === 'private'; // 判断是否私有化
        // let upLoadUrl;
        // if (isPre) {
        //     // 私有化路径
        //     const baseConfigTenat = store.getters['routes/tenantInfo'];
        //     upLoadUrl = baseConfigTenat.unittype + '/' + baseConfigTenat.bossProductInstance;
        // } else {
        //     const instance = getAccessInstance();
        //     let { unittype } = JSON.parse(sessionStorage.getItem('thyTenantInfo'));
        //     // sass 路径
        //     upLoadUrl = unittype + '/' + instance;
        // }
        // return upLoadUrl;
        let { unittype, instance , productGroupId } = JSON.parse(sessionStorage.getItem('thyTenantInfo'));
        let upLoadUrl
        if(store.state.$is2024){
            upLoadUrl = unittype + '/' + productGroupId.toLowerCase();
        }else{
            upLoadUrl = unittype + '/' + instance.toLowerCase();
        }
        return upLoadUrl;
    },
    // 回显前缀
    basePreUrl(type) {
        //const isPre = loginInterceptionType === 'private'; // 判断是否私有化
        let { cdnFlag } = JSON.parse(sessionStorage.getItem('thyTenantInfo'));
        let basePreUrl;
        if (cdnFlag == '3') {
            // 私有化路径
            // const instance = getAccessInstance();
            // basePreUrl = 'http://' + instance + '.p.oper.test-dcloud.shop1.shop.yun300.cn/repository/';
            basePreUrl = '/repository/';
            // if (makeDomain) {
            //     basePreUrl = '/' + makeDomain + '/repository/';
            // } else if (mobileMakeDomain) {
            //     basePreUrl = '/' + mobileMakeDomain + '/repository/';
            // }
        } else {
            switch (type) {
                // 图片地址前缀
                case 0:
                    basePreUrl = Vue.prototype.$baseUrlImg;
                    break;
                // 视频地址前缀
                case 1:
                    basePreUrl = Vue.prototype.$baseUrlVideo;
                    break;
                // 文件地址前缀
                case 2:
                    basePreUrl = Vue.prototype.$baseUrlFile;
                    break;
            }
        }
        return basePreUrl;
    },
    //flag:是否缩略图,默认是缩略图 noDate:是否没有时间戳，默认有
    getResourceUrl(url, type, flag, noDate) {
        if (!url) return '';
        let { cdnFlag } = JSON.parse(sessionStorage.getItem('thyTenantInfo'));
        let baseUrl = this.basePreUrl(type);
        let reg = /(http|https):\/\/([\w.]+\/?)\S*/;
        if (!reg.test(url)) {
            if (type == 0 && !flag && cdnFlag !== '3') {
                return dealsrc(baseUrl.charAt(baseUrl.length - 1) == '/' ? baseUrl + url : baseUrl + '/' + url, noDate);
            } else {
                return baseUrl.charAt(baseUrl.length - 1) == '/' ? baseUrl + url : baseUrl + '/' + url;
            }
        } else {
            if (type == 0 && !flag && cdnFlag !== '3') {
                return dealsrc(url, noDate);
            } else {
                return url;
            }
        }
    },

};
export function baseUrlFile() {
    //const isPre = loginInterceptionType === 'private'; // 判断是否私有化
    let { cdnFlag } = JSON.parse(sessionStorage.getItem('thyTenantInfo'));
    let baseUrl;
    if (cdnFlag == '3') {
        // 私有化路径
        baseUrl = {
            baseURLFile: '',
            baseURLFileCdn: '',
            baseURLImgCdn: '',
            baseURLVedioCdn: '',
            recordURL: '',
        };
    } else {
        // sass 路径
        baseUrl = {
            // baseURLFile: 'https://pre-omo-gateway.site.cn',
            // baseURLFileCdn: 'https://pre-omo-oss-file.site.cn',
            // baseURLImgCdn: 'https://pre-omo-oss-image.site.cn/',
            // baseURLVedioCdn: 'https://pre-omo-oss-vedio.site.cn/',
            baseURLFile: Vue.prototype.$baseUrlUpolad,
            baseURLFileCdn: Vue.prototype.$baseUrlFile,
            baseURLImgCdn: Vue.prototype.$baseUrlImg,
            baseURLVedioCdn: Vue.prototype.$baseUrlVideo,
        };
    }
    return baseUrl;
}
